export default "__VITE_ASSET__Dnd5$FoW__"